import { StandardPartOfferResponseDTO } from '@luminovo/api-contracts';
import { extractAmountFromMonetaryValue, isPresent, MonetaryValue, QuantityHelper } from '@luminovo/commons';

import { Solution } from '../../types';

export function extractMpq({
    solution,
}: {
    solution: Pick<Solution, 'offerIdAndSignature' | 'unit'> | undefined;
}): number | undefined {
    if (!isPresent(solution)) {
        return undefined;
    }

    const signature = solution.offerIdAndSignature.signature;
    if (signature && 'mpq' in signature) {
        return signature.mpq * QuantityHelper.from(solution.unit).parseValue();
    }
    return undefined;
}

export function extractMpqFromOffer(
    unitPriceOriginal: MonetaryValue | null,
    offer: StandardPartOfferResponseDTO,
): number | undefined {
    const matchingPriceBreak = offer.price_breaks.find(
        (priceBreak) =>
            extractAmountFromMonetaryValue(priceBreak.unit_price) ===
                extractAmountFromMonetaryValue(unitPriceOriginal) &&
            unitPriceOriginal?.currency === priceBreak.unit_price.currency,
    );

    return matchingPriceBreak?.minimum_packaging_quantity;
}
